
import {
    defineComponent,
    ref,
    onMounted,
    provide,
    inject
} from "vue"
import {
    Search
} from "@element-plus/icons-vue"

//services
import personServ from "@/core/services/PersonService"

//componentes
import DialogDetails from "./ModalDetails.vue"
import ModalRegister from "./ModalRegister.vue"

export default defineComponent({
    name: "Persons",
    components: {
        DialogDetails, ModalRegister
    },
    setup() {
        const typeFilter = ref([{
            id: 1,
            name: "ID"
        },
        {
            id: 2,
            name: "Documento",
        },
        {
            id: 3,
            name: "Nombre y apellido"
        }
        ])

        const filter = ref({
            option: 2,
            text: ""
        });
        const loading = ref(false)

        const listPersons = ref([])
        //Pagination start
        const pageSize = ref(10)
        const currentPage = ref(1)
        const totalItems = ref(0)
        //pagination end

        //dialogs
        const dialog_details = ref(false)
        const dialog_register = ref(false)

        // variables compartidas
        provide('dialog_details', dialog_details)
        provide('dialog_register', dialog_register)

        //get variables compartidas
        const gblPersona = inject<any>('gblPersona')

        const getData = async () => {
            loading.value = true
            listPersons.value.slice(0, listPersons.value.length)
            await personServ.getData({
                option: filter.value.option,
                search: filter.value.text,
                pageSize: pageSize.value,
                currentPage: currentPage.value
            })
                .then((res) => {
                    listPersons.value = res.data.list
                    totalItems.value = res.data.total
                    loading.value = false
                }).catch(({
                    response
                }) => {
                    loading.value = false
                })
        }

        const handleCurrentChange = (val: number) => {
            currentPage.value = val
            getData()
        }

        const openModalDetails = (item) => {
            gblPersona.value = item
            dialog_details.value = true
        }

        const openModalRegister = () => {
            dialog_register.value = true
        }

        const onResponse = (data) => {
            if(data.status == 'success'){
                dialog_register.value = false
                 getData()
            }
               
        }

        onMounted(() => {
            getData();
        })

        return {
            typeFilter,
            filter,
            Search,
            loading,
            listPersons,
            pageSize,
            currentPage,
            totalItems,
            getData,
            handleCurrentChange,
            gblPersona,
            dialog_details,
            openModalDetails,
            openModalRegister,
            onResponse
        }

    },
})
